import { ModalityType } from '@asktia/tia-fhir-questionnaire/dist/src/validators/QuestionnaireResponse'
import { useMutation } from 'react-query'
import { fetcher } from 'src/fetcher'
import { BASE_API_URL } from 'src/globals'
import logger from 'src/logger'

export type OpenLoopIntakeSubmissionResponse = {
    outcome: ModalityType
    openLoopBookingLink?: string
}

async function submitQuestionnaireResponse(
    questionnaireId: string
): Promise<OpenLoopIntakeSubmissionResponse> {
    return fetcher(
        `${BASE_API_URL}/awell-api/open-loop/intake/submit`,
        JSON.stringify({
            questionnaireId,
            serviceLine: 'mwl'
        }),
        'POST',
        {
            customErrorHandler: (res: Response) => {
                res.text().then(body => {
                    logger.error(
                        `Unexpected error on submitting questionnaire - useSubmitQuestionnaireResponse.`,
                        {
                            questionnaireId,
                            status: res.status,
                            errorBody: body
                        }
                    )
                })

                return new Error('Server returned not-ok')
            }
        }
    )
}

export const useSubmitQuestionnaireResponse = () => {
    const { mutateAsync, isLoading, isSuccess, isError } = useMutation(
        submitQuestionnaireResponse
    )

    return {
        isLoading,
        isSuccess,
        isError,
        submitQuestionnaireResponse: mutateAsync
    }
}
